export const BREAKPOINT_MOBILE = 576;
export const BREAKPOINT_LARGE = 1625;

export const MOBILE_PADDING = 24;
export const VIEWPORT_PADDING_PERCENTAGE = 0.1;
